// DON'T DELETE THIS COMMENT CODE
// export enum RefundStatusEnum {
//   //TAB PROCESSED
//   processed = 'processed',

//   //TAB NEED APPROVAL
//   draft = 'draft',
//   draft_cancel = 'draft_cancel',
//   pending_cancel = 'pending_cancel',
//   pending_approval = 'pending_approval',

//   //TAB REJECTED APPROVAL
//   rejected_approval = 'rejected_approval',
//   rejected_release_approval = 'rejected_release_approval',

//   // TAB COMPLETED
//   cancel = 'cancel',
//   completed = 'completed',

//   //HIDDEN
//   waiting = 'waiting',
//   archived = 'archived',
// }

// DON'T DELETE THIS COMMENT CODE
// export enum ReleaseStatusEnum {
//   //PROCESSED
//   requested = 'requested',

//   //NEED APPROVAL
//   draft = 'draft',
//   draft_refund = 'draft_refund',
//   draft_cancel_refund = 'draft_cancel_refund',
//   pending_approval = 'pending_approval',
//   pending_release_approval = 'pending_release_approval',
//   pending_cancel_refund = 'pending_cancel_refund',
//   pending_refund = 'pending_refund',

//   //REJECT APPROVAL
//   rejected_approval = 'rejected',
//   rejected_release_approval = 'rejected_release_approval',
//   reject_refund = 'reject_refund',

//   //COMPLETED
//   completed = 'completed',
//   cancel_refund = 'cancel_refund',

//   //HIDDEN
//   archived = 'archived',
//   waiting = 'waiting',
// }

export enum RefundTabEnum {
  Processed = 'processed',
  NeedApproval = 'need_approval',
  RejectedApproval = 'rejected_approval',
  Complete = 'complete',
  Submitted = 'submitted',
  Canceled = 'canceled',
}
